import { Box, SxProps, Theme, Typography, useTheme } from "@mui/material";
import { IReportScheduleSummaryDTO } from "../../services/reporting-data-service/ReportScheduleModels";
import ScheduledReportsListUtils from "./ScheduledReportsListUtils";
import { getTimeframeTimeDisplayText } from "../../common/utilities/TimeframeUtilities";
import { TimeframeTypeEnum } from "../../common/enums/TimeframeTypeEnum";
import { useTranslation } from "react-i18next";
import { Block } from "@mui/icons-material";

export type ScheduleSummaryCardProps = {
    item: IReportScheduleSummaryDTO,
    sx?: SxProps<Theme>;
};

export function ScheduleSummaryCard({
    item,
    sx
}: ScheduleSummaryCardProps) {

    const theme = useTheme();
    const {t} = useTranslation();

    return (

        <Box sx={{
            backgroundColor: "custom.background.cardContainer",
            marginLeft: 6,
            marginRight: 1,
            padding: 1,
            ...sx
        }}>

            <Typography variant="body2"
                sx={{
                    color: theme.palette.grey[600],
                }}>
                {!item.isActive &&
                    <Block sx={{
                        fontSize: '1rem',
                        verticalAlign: 'middle',
                    }} />
                }
                {item.description}
            </Typography>

            <Typography variant="body2">
                {ScheduledReportsListUtils.getScheduleSummary(item)}
            </Typography>

            {item.lastRunTime && 
            <Typography variant="body2">
                {t('scheduledReports.lastRun', {ts: getTimeframeTimeDisplayText(TimeframeTypeEnum.None, item.lastRunTime)})}
            </Typography>
            }


        </Box>    

    );
}
